import { Component, OnInit } from '@angular/core';
import { PageFrameService } from './fs-page-frame.service';

@Component({
  selector: 'fs-page-frame',
  templateUrl: './fs-page-frame.component.html',
  styleUrls: ['./fs-page-frame.component.scss'],
})
export class FsPageFrameComponent implements OnInit {
  constructor(public pageFrameService: PageFrameService) {}

  ngOnInit(): void {}

  onSearch(event: any): void {
    this.pageFrameService.setSearchInput(event.target.value);
  }

  isShowHeader(): boolean {
    return (
      this.pageFrameService.isActiveSearchBox ||
      this.pageFrameService.isActiveHistoryState
    );
  }
}
